import { Injectable } from '@angular/core';
import { ChangesModel } from 'projects/phdsoft/common/src/lib/models/changes.model';
import { AssetManager } from './asset-manager';
import { AssetManagerInspection } from './asset-manager-inspection';
import { DigitalTwinService } from '../digital-twin/digital-twin.service';
import { AssetLoader } from '../digital-twin/Loader/AssetLoader';
import { DTSelectionService } from '../digital-twin/selection/selection.service';
import { GraphicsMaterials } from '../digital-twin/graphics/graphics-materials';
import { ViewModeStructureLabelsService } from '../template/view-mode-tools/view-mode-structure-labels/view-mode-structure-labels.service';

@Injectable({
  providedIn: 'root'
})
export class AssetManagerLoaderService {


  constructor(
    private assetManager: AssetManager,
    public readonly DTService: DigitalTwinService,
    public readonly assetLoader: AssetLoader,
    public readonly graphicsMaterial: GraphicsMaterials,
    public readonly selectionService: DTSelectionService,
    private viewModeStructureLabelsService: ViewModeStructureLabelsService,
    private assetManagerInspection: AssetManagerInspection,
  ) {}

  /** An explorer-driven region/section switch ends the "change inspection target" tool (the mode setter clears its picks). */
  private stopInspectionRetarget(): void {
    if (this.assetManagerInspection.retarget?.isRetargetMode()) this.assetManager.setFunctionalityModeNone();
  }

  private updateStructuralLabelsIfActive(): void {
    if (this.viewModeStructureLabelsService.isActive) {
      console.log('🔄 AssetManagerLoader: Updating structural labels due to model change', {
        currentMode: this.assetManager.asset?.mode,
        selectedElementType: this.viewModeStructureLabelsService.selectedElementType,
        currentRegion: this.assetManager.currentRegion?.Guid,
        currentSection: this.assetManager.currentSection?.Guid
      });
      this.viewModeStructureLabelsService.refreshStructuralLabels(this.assetManager);
    }
  }

  async verifyRegionAndSection(currentItem: ChangesModel) {
    // this.showLoadingInfo = true;
    await this.loadAssetAndDifferentRegion(currentItem)
    if (currentItem.regionId) {
      const index = this.assetManager.asset.assetInfo.Regions.findIndex(x => x.id === currentItem.regionId);
      if (index > -1)
      this.assetManager.asset.assetInfo.Regions[index].selected = true;
    }
    
    this.updateStructuralLabelsIfActive();
    
    // this.showLoadingInfo = false
  }

  async loadAssetAndDifferentRegion(nextRegionToLoad: ChangesModel) {
    if (this.assetManager.asset.StructureCampaigns[0].regionsWorkableElements.findIndex(item => item.Guid === nextRegionToLoad.regionId) === -1) {
      await this.DTService.getAssetById(nextRegionToLoad.assetId);
      await this.assetLoader.loadNewRegion(nextRegionToLoad.regionId);
      
      this.updateStructuralLabelsIfActive();
    }
  }

  highlightRegion(selectedItem: ChangesModel) {
      this.stopInspectionRetarget();
      switch (this.assetManager.asset.mode) {
        case 'MODEL':
          this.selectionService.selectRegion(selectedItem.regionId, this.assetManager.asset);
          break;
        case 'REGIONS':
          // if (this.assetManager.currentRegion.Guid !== selectedItem.regionId) {
            this.selectionService.selectRegion(selectedItem.regionId, this.assetManager.asset);
          // }
          break;
        case 'SECTIONS':
          // if (this.assetManager.currentRegion.Guid !== selectedItem.regionId) {
            this.selectionService.selectRegion(selectedItem.regionId, this.assetManager.asset);
          // }
          break;
        default:
          break;
      }
      
      this.updateStructuralLabelsIfActive();
  }

  highlightSection(selectedItem: ChangesModel) {
      this.stopInspectionRetarget();
      this.assetManager.asset.mode = 'SECTIONS'
      this.selectionService.setSelectSection(selectedItem.regionId, selectedItem.sectionId, this.assetManager.asset);
      
      this.updateStructuralLabelsIfActive();
  }

}
